import { CONTRACT_FINE_TYPE } from "../../../../../../../../types/payment.type";


export function useBillingForm() {

  const optionsBillingCharge = Object.entries(CONTRACT_FINE_TYPE).map(([key, value]) => ({
    value: key, // Retorna a chave do enum (ex: "RESCISSION")
    label: value, // Retorna o valor legível (ex: "Rescisão")
  }));

  const LicensePlateInput = [
    "PROTECTION",
    "MAINTENANCE_MISUSE",
    "LICENSING",
    "REAL_DRIVER_REMOVAL",
    "KEY_REPLACEMENT"
  ];

  return {
    optionsBillingCharge,
    LicensePlateInput
  }
}